import {
  Box,
  Grid,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import React from "react";
import { Edit, SelectInput, SimpleForm, useRecordContext } from "react-admin";
import LinkToBankProducts from "../partners/LinkToBankProducts";
import HmTextInput from "../unit/HmTextInput";
import formatPhone from "../unit/inputFormat/formatPhone";
import parseNumber from "../unit/inputFormat/parseNumber";
import parsePhone from "../unit/inputFormat/parsePhone";
import validateNumber from "../unit/inputFormat/validateNumber";
import YesNoInput from "../unit/YesNoInput";
import useNotify from "../unit/useNotify";
import sendRequest from "../dataProvider/sendRequest";
import { CopyAllOutlined } from "@mui/icons-material";
import RefreshIcon from "@mui/icons-material/Refresh";
import EnabledDisabledInput from "../unit/EnabledDisabledInput";
const ShowOriginalName = () => {
  const record = useRecordContext();
  return (
    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
      {record?.sName}
    </Typography>
  );
};

const VendorLink = ({ ...props }) => {
  const id = props.id;
  const record = useRecordContext();
  const [vendorLink, setVendorLink] = React.useState(record?.share_url || "");
  const { success } = useNotify();
  const handleClick = () => {
    let reqUrl = "general/vendorlink";
    sendRequest(reqUrl, { id: id }).then((response) => {
      if (response) {
        setVendorLink(response?.url);
      }
    });
  };
  const handleCopy = () => {
    navigator.clipboard.writeText(vendorLink);
    success("Link copied to clipboard");
  };
  return (
    <Box>
      <TextField
        id="outlined-basic"
        label="Vendor URL"
        variant="outlined"
        value={vendorLink}
        sx={{
          width: "100%",
          "& input.Mui-readOnly": {
            backgroundColor: "#ddd",
            borderRadius: "10px",
          },
        }}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={"Generate URL"}
                onClick={handleClick}
                edge="end"
                disabled={vendorLink ? true : false}
              >
                <RefreshIcon color={vendorLink ? "disabled" : "primary"} />
              </IconButton>

              <IconButton
                aria-label={"Copy URL"}
                onClick={handleCopy}
                edge="end"
                sx={{ marginLeft: "20px" }}
              >
                <CopyAllOutlined color="primary" />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

const VendorAccountType = ({ ...props }) => {
  const record = useRecordContext();
  const [accountType, setAccountType] = React.useState(record?.sAccountType);
  return (
    <SelectInput
      source="sAccountType"
      variant="outlined"
      label="Account Type"
      value={accountType}
      onChange={(e: any) => {
        setAccountType(e.target.value);
      }}
      choices={[
        // { id: "", name: "Select" },
        { id: "savings", name: "Saving" },
        { id: "checking", name: "Checking" },
      ]}
      required={true}
      helperText={false}
    />
  );
};

const VendorAccountSection = ({ ...props }) => {
  const record = useRecordContext();
  const [showSetting, setShowSetting] = React.useState(
    record?.sInstitutionName ? "Yes" : "No"
  );
  return (
    <>
      <YesNoInput
        source="sSetUpAch"
        label="Set Up ACH Transfer"
        defaultValue={showSetting}
        onChange={(e: any) => {
          if (e.target.value == "Yes") {
            setShowSetting("Yes");
          } else {
            setShowSetting("No");
          }
        }}
        helperText={false}
        sx={{ mt: 0, mb: 0 }}
      />
      {showSetting == "Yes" && (
        <Box>
          <HmTextInput
            source="sInstitutionName"
            label="Bank Name"
            required={true}
            disabled={record?.sInstitutionName ? true : false}
          />
          <VendorAccountType
            source="sAccountType"
            disabled={record?.sAccountType ? true : false}
          />
          <HmTextInput
            source="sRoutingNumber"
            label="Routing Number"
            required={true}
            disabled={record?.sRoutingNumber ? true : false}
          />
          <HmTextInput
            source="sAccountNumber"
            label="Account Number"
            required={true}
            disabled={record?.sAccountNumber ? true : false}
          />
        </Box>
      )}
    </>
  );
};
const VendorStatusField = ({ ...props }) => {
  const record = useRecordContext();
  return (
    <>
      <Typography variant="body1" color="error" sx={{ mb: 2 }}>
        Note: If no product is selected, the status will automatically be set to
        disabled. To enable it, please select at least one product.
        {/* {record?.sStatus != "Enabled" && (
          <EnabledDisabledInput
            source="sStatus"
            name="sStatus"
            label="Status"
          />
        )} */}
      </Typography>
    </>
  );
};
const VendorsEdit = (props: any) => {
  const [activeTab, setActiveTab] = React.useState(0);
  const [showEditAccountSection, setShowEditAccountSection] =
    React.useState(false);
  const curTab = props?.curTab;
  const productList = props?.productList;
  const handleChange = (newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Edit
      {...props}
      basePath="/vendors"
      resource="vendors"
      sx={{
        marginTop: "0px",
        ".MuiPaper-root": { border: "none", borderRadiue: "none" },
      }}
      // actions={null}
      className="vendors_edit_dialog_form"
    >
      <SimpleForm toolbar={false}>
        <Box sx={{ width: "100%", pt: 0 }}>
          <Box
            sx={{
              width: "100%",
              borderBottom: 1,
              borderColor: "divider",
              marginTop: "0px",
              ".MuiCardContent": { paddingTop: 0 },
            }}
          >
            <ShowOriginalName />
          </Box>
          <>
            {curTab && curTab == "info" && (
              <Box
                sx={{
                  // display: activeTab === 0 ? "block" : "none",
                  pt: 2,
                  pb: 2,
                }}
              >
                <HmTextInput
                  source="sName"
                  label="Organization Name"
                  required={true}
                />

                <Grid
                  container
                  spacing={1}
                  sx={{
                    mt: "0px",
                    "& .MuiGrid-item": {
                      pt: 0,
                    },
                  }}
                >
                  <Grid item xs={8}>
                    <HmTextInput
                      source="sStreet"
                      label="Street"
                      required={true}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <HmTextInput source="sStreet2" label="Street2" />
                  </Grid>
                  <Grid item xs={4}>
                    <HmTextInput source="sCity" label="City" required={true} />
                  </Grid>
                  <Grid item xs={4}>
                    <HmTextInput
                      source="sState"
                      label="State"
                      required={true}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <HmTextInput source="sZip" label="Zip" required={true} />
                  </Grid>
                </Grid>
                {/* <HmTextInput
                  source="sFirstName"
                  label="First Name"
                  required={true}
                />
                <HmTextInput
                  source="sLastName"
                  label="Last Name"
                  required={true}
                /> */}
                <HmTextInput
                  source="sContactName"
                  name="sContactName"
                  label="Contact Name"
                  required={true}
                />
                <HmTextInput
                  source="sContactEmail"
                  name="sEmail"
                  label="Contact Email"
                  required={true}
                />
                <HmTextInput
                  source="sContactPhone"
                  name="sPhone"
                  label="Contact Phone"
                  required={true}
                  format={formatPhone}
                  parse={parsePhone}
                />

                <HmTextInput
                  source="iMaxLoanAmount"
                  label="Set unique maximum loan amount"
                  required={true}
                  validate={validateNumber}
                  parse={parseNumber}
                />
                <HmTextInput
                  source="iMaxApplicationFee"
                  label="Set unique application fee"
                  required={true}
                  validate={validateNumber}
                  parse={parseNumber}
                />
                <VendorAccountSection />
                {/* <EnabledDisabledInput
                source="sStatus"
                name="sStatus"
                label="Status"
              /> */}
              </Box>
            )}
            {curTab && curTab == "special" && (
              <Box
                sx={{
                  // display: activeTab === 1 ? "block" : "none",
                  pt: 2,
                  pb: 2,
                }}
              >
                {/* <YesNoInput
                source="sUniqueApplicationFee"
                label="Set unique application fee"
                onChange={(e: any) => {}}
                helperText={false}
                sx={{ mt: 0, mb: 0 }}
              />
              <Box>
                <HmTextInput
                  source="sInstitutionName"
                  label="Bank Name"
                  required={true}
                />
                <VendorAccountType source="sAccountType" />
                <HmTextInput
                  source="sRoutingNumber"
                  label="Routing Number"
                  required={true}
                />
                <HmTextInput
                  source="sAccountNumber"
                  label="Account Number"
                  required={true}
                /> 
              </Box>*/}
              </Box>
            )}
            {curTab && curTab == "linkProducts" && (
              <Box
                sx={{
                  // display: activeTab === 2 ? "block" : "none",
                  pt: 2,
                  pb: 2,
                }}
              >
                <VendorStatusField />
                <LinkToBankProducts productList={productList} />
              </Box>
            )}
            {curTab && curTab == "uniqueURL" && (
              <Box
                sx={{
                  pt: 2,
                  pb: 2,
                  width: "100%",
                }}
              >
                <VendorLink
                  id={props.id}
                  source="share_url"
                  label="Website for Online Purchase"
                />
              </Box>
            )}
          </>
        </Box>
      </SimpleForm>
    </Edit>
  );
};

export default VendorsEdit;
